import DialogueType from '../../../../src/components/questions/DialogueType';
import { getNpcCharacters } from '~lib/common/utils/characters';
import { dialogueMsg } from '../validationMessages';
import { AiPromptRoleInvalidTypes, AiPromptRoleTypes, findRoleSuggestion } from './npcRoles';

export default function validateNpcs(caseConf) {
  // Currently, these only apply to AI dialogue, so skip if AI is off
  const dialogue = caseConf.dialogue || {};
  const isAiDialogueEnabled = dialogue.aiEnabled;
  if (!isAiDialogueEnabled) return;

  const warnings = [];
  const errors = [];
  const npcs = getNpcCharacters(caseConf) || [];
  const dialogueType = DialogueType.AI_NPC_PROMPT;
  const roleErrorMsg = (msg, metadata) => dialogueMsg(msg, 'role', metadata);
  const roleWarningMsg = (msg, metadata) => dialogueMsg(msg, 'role', metadata);

  function validateRoleUnique(usedRoles, npc) {
    if (usedRoles[npc.role] && usedRoles[npc.role].npcKey !== npc.key) {
      const otherNpcLabel = usedRoles[npc.role].npcLabel;
      const msg = `${npc.label} role cannot be equal to ${otherNpcLabel} role`;
      const characterKey = npc.key;
      const metadata = { characterKey, dialogueType };
      errors.push(roleErrorMsg(msg, metadata));
    }
  }

  function validateRoleType(npc) {
    if ([...AiPromptRoleInvalidTypes, ...AiPromptRoleTypes].includes(npc.role)) {
      const msg = `${npc.label} role is reserved or invalid`;
      const characterKey = npc.key;
      const metadata = { characterKey, dialogueType };
      errors.push(roleErrorMsg(msg, metadata));
    }
  }

  function validateRoleFormat(npc) {
    if (!/^[A-Z_]+$/.test(npc.role)) {
      const msg = `${npc.label} role may only contain uppercase letters (A-Z) and underscores`;
      const characterKey = npc.key;
      const metadata = { characterKey, dialogueType };
      errors.push(roleErrorMsg(msg, metadata));
    }
  }

  function validateRoleSpelling(npc) {
    // Only warn on likely misspellings of a known role; deliberate custom
    // roles (not near any suggestion) are left alone.
    const suggestion = findRoleSuggestion(npc.role);
    if (suggestion) {
      const msg = `${npc.label} role "${npc.role}" isn't a common role — did you mean ${suggestion}?`;
      const characterKey = npc.key;
      const metadata = { characterKey, dialogueType };
      warnings.push(roleWarningMsg(msg, metadata));
    }
  }

  const usedRoles = {};

  // Validate role
  for (const npc of npcs) {
    const characterKey = npc.key;
    const metadata = { characterKey, dialogueType };
    if (!npc.role) {
      const msg = `${npc.label} role cannot be empty`;
      errors.push(roleErrorMsg(msg, metadata));
    }
    else {
      validateRoleUnique(usedRoles, npc);
      usedRoles[npc.role] = {
        npcKey: npc.key,
        npcLabel: npc.label
      };
      validateRoleType(npc);
      validateRoleFormat(npc);
      validateRoleSpelling(npc);
    }
  }

  return {
    errors,
    warnings,
  };
}